/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { RaisedButton, CircularProgress, Subheader } from 'material-ui'
import SentimentVeryStatisfied from 'material-ui/svg-icons/social/sentiment-very-satisfied'
import SentimentStatisfied from 'material-ui/svg-icons/social/sentiment-satisfied'
import SentimentNeutral from 'material-ui/svg-icons/social/sentiment-neutral'
import SentimentDisStatisfied from 'material-ui/svg-icons/social/sentiment-dissatisfied'
import SentimentVeryDisStatisfied from 'material-ui/svg-icons/social/sentiment-very-dissatisfied'
import {greenA400, yellowA400, orangeA400, redA400, grey400} from 'material-ui/styles/colors'

import { TextField } from 'generic/form'

import BaseValidation from 'components/common/BaseValidation'
import Section from './Section'
import * as constants from 'constants/Prestation'
import * as actions from 'actions/ApplicantPrestation'
import Request from 'generic/request/Request'

class PrestationEvaluation extends React.Component {
  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      evaluation: undefined,
      loading: false,
      sent: false,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      },
      satisfactionIcons: [
        {
          icon: <SentimentNeutral color={grey400} style={styles.icon}/>
        },
        {
          icon: <SentimentVeryDisStatisfied color={redA400} style={styles.icon}/>
        },
        {
          icon: <SentimentDisStatisfied color={orangeA400} style={styles.icon}/>
        },
        {
          icon: <SentimentStatisfied color={yellowA400} style={styles.icon}/>
        },
        {
          icon: <SentimentVeryStatisfied color={greenA400} style={styles.icon}/>
        },
      ],
      satisfactionButtons: [
        {
          label: this.props.intl.formatMessage(constants.messages.INSUFFISANT),
          value: constants.INSUFFISANT,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.SUFFISANT),
          value: constants.SUFFISANT,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.GOOD),
          value: constants.GOOD,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.VERY_GOOD),
          value: constants.VERY_GOOD,
        },
      ],
      opinionButtons: [
        {
          label: this.props.intl.formatMessage(constants.messages.NO_ANSWER),
          value: null,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.NOT_AT_ALL),
          value: constants.NOT_AT_ALL,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.RATHER_NO),
          value: constants.RATHER_NO,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.RATHER_YES),
          value: constants.RATHER_YES,
        },
        {
          label: this.props.intl.formatMessage(constants.messages.ABSOLUTELY),
          value: constants.ABSOLUTELY,
        },
      ],
    }
  }

  componentDidMount() {
    this.handleEvaluation()
  }

  handleEvaluation() {
    this.setState({
      loading: true
    })

    actions.getPrestationEvaluation(this.props.match.params.uid,
                                    this.props.match.params.token)
      .then((result) => {
        this.setState({
          evaluation: result,
          loading: false
        })
      })
      .catch((error) => {
        if (error &&
            (error.response.status === 404 ||
             error.response.status === 400)) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.response.data.errors[0].user_message,
            },
            loading: false
          })
        }
      })
  }

  handleEvaluationChange(name, value) {
    this.setState({
      evaluation: {
        ...this.state.evaluation,
        [name]: value
      }
    })
  }

  handleSend() {
    this.setState({
      loading: true
    })

    actions.postPrestationEvaluation(this.state.evaluation,
                                     this.props.match.params.uid,
                                     this.props.match.params.token)
      .then((result) => {
        this.setState({
          loading: false,
          sent: true
        })
      })
      .catch((error) => {
        if (error && (error.status === 400 || error.status === 401)) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: R.path(['data', 'errors', 0, 'user_message'], error),
              errorFields: Request.getFieldErrorObject(error.data.field_errors)
            },
            loading: false
          })
        }
      })
  }

  handleCancel() {
    this.props.history.push({pathname: '/dashboard/'})
  }

  handleLogin() {
    this.props.history.push({pathname: '/login/'})
  }

  render () {
    const evaluation = this.state.evaluation

    return (
      <BaseValidation>
        {
          this.state.errors.errorMessage && !Object.keys(this.state.errors.errorFields).length
            ? <div
              style={{...styles.message,...{color: 'red'}}}
            >
              { this.state.errors.errorMessage }
            </div>
            : <div
              style={styles.container}
            >
              {
                this.state.sent
                  ? <div>
                    <div style={styles.message}>
                      {this.props.intl.formatMessage(constants.messages.PRESTATION_EVALUATION_SENT)}
                    </div>

                    <RaisedButton
                      label={this.props.intl.formatMessage(constants.messages.BACK_TO_LOGIN)}
                      primary={true}
                      onClick={this.handleLogin}
                      style={{
                        ...styles.button,
                        marginTop: 30,
                        height: 40
                      }}
                    />
                  </div>
                  : <React.Fragment>
                    <h2>
                      {this.props.intl.formatMessage(constants.messages.PRESTATION_EVALUATION)} {this.props.match.params.uid}
                    </h2>

                    <div
                      style={{textAlign: 'justify'}}
                      className='col-md-offset-3 col-md-6 col-xs-8'
                    >
                      <span>{this.props.intl.formatMessage(constants.messages.PRESTATION_EVALUATION_DESCRIPTION)}</span>
                      <span
                        style={{fontStyle: 'italic'}}
                      >
                        {this.props.intl.formatMessage(constants.messages.PRESTATION_OPTIONAL_DESCRIPTION)}
                      </span>
                    </div>

                    <div
                      className='col-md-offset-3 col-md-6 col-xs-6'
                      style={styles.form}
                    >
                      {
                        this.state.loading
                          ? <CircularProgress
                            size={100}
                          />
                          : <React.Fragment>
                            {/* Satisfaction */}
                            <Section
                              name='satisfaction_note'
                              style={styles.section}
                              title={this.props.intl.formatMessage(constants.messages.SATISFACTION)}
                              buttons={this.state.satisfactionButtons}
                              icons={this.state.satisfactionIcons}
                              value={evaluation ? evaluation.satisfaction_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            {/* Interpretation */}
                            <Section
                              name='interpretation_note'
                              style={styles.section}
                              title={this.props.intl.formatMessage(constants.messages.INTERPRETATION)}
                              subHeader={this.props.intl.formatMessage(constants.messages.INTERPRETATION_NOTE)}
                              buttons={this.state.opinionButtons}
                              icons={this.state.satisfactionIcons}
                              value={evaluation ? evaluation.interpretation_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            <Section
                              name='understanding_note'
                              style={styles.section}
                              subHeader={this.props.intl.formatMessage(constants.messages.UNDERSTANDING_NOTE)}
                              buttons={this.state.opinionButtons}
                              value={evaluation ? evaluation.understanding_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            <Section
                              name='communication_note'
                              style={styles.section}
                              subHeader={this.props.intl.formatMessage(constants.messages.COMMUNICATION_NOTE)}
                              buttons={this.state.opinionButtons}
                              value={evaluation ? evaluation.communication_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            {/* Organisation */}
                            <Section
                              name='organisation_note'
                              style={styles.section}
                              title={this.props.intl.formatMessage(constants.messages.ORGANISATION)}
                              subHeader={this.props.intl.formatMessage(constants.messages.ORGANISATION_NOTE)}
                              buttons={this.state.opinionButtons}
                              icons={this.state.satisfactionIcons}
                              value={evaluation ? evaluation.organisation_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            <Section
                              name='process_note'
                              style={styles.section}
                              subHeader={this.props.intl.formatMessage(constants.messages.PROCESS_NOTE)}
                              buttons={this.state.opinionButtons}
                              value={evaluation ? evaluation.process_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            <Section
                              name='complementary_tool_note'
                              style={styles.section}
                              subHeader={this.props.intl.formatMessage(constants.messages.COMPLEMENTARY_TOOLS_NOTE)}
                              buttons={this.state.opinionButtons}
                              value={evaluation ? evaluation.complementary_tool_note : undefined}
                              handleEvaluationChange={this.handleEvaluationChange}
                            />

                            <div
                              className='row'
                            >
                              <Section
                                title={this.props.intl.formatMessage(constants.messages.FEED_BACK)}
                                subHeader={this.props.intl.formatMessage(constants.messages.REMARKS)}
                              />

                              <div
                                className='col-md-12 col-xs-12'
                              >
                                <TextField
                                  name='remarks'
                                  floatingLabelText={this.props.intl.formatMessage(constants.messages.COMMENT)}
                                  multiLine={true}
                                  rows={4}
                                  rowsMax={4}
                                  value={evaluation ? evaluation.remarks : undefined}
                                  onChange={(event, value) => this.handleEvaluationChange(event.target.name, value)}
                                  style={styles.field}
                                  errorText={this.state.errors.errorFields.remarks}
                                />
                              </div>
                            </div>

                            <div
                              className='row'
                              style={styles.section}
                            >
                              <Subheader style={{lineHeight: '25px'}}>
                                {this.props.intl.formatMessage(constants.messages.CONTACT_INFORMATION)}
                              </Subheader>

                              <div
                                className='col-md-4 col-xs-12'
                              >
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(constants.messages.NAME)}
                                  name='name'
                                  value={evaluation ? evaluation.name : undefined}
                                  onChange={(event, value) => this.handleEvaluationChange(event.target.name, value)}
                                  errorText={this.state.errors.errorFields.name}
                                  style={styles.field}
                                />
                              </div>

                              <div
                                className='col-md-4 col-xs-12'
                              >
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(constants.messages.PHONE)}
                                  name='phone_number'
                                  value={evaluation ? evaluation.phone_number : undefined}
                                  onChange={(event, value) => this.handleEvaluationChange(event.target.name, value)}
                                  errorText={this.state.errors.errorFields.phone_number}
                                  style={styles.field}
                                />
                              </div>

                              <div
                                className='col-md-4 col-xs-12'
                              >
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(constants.messages.EMAIL)}
                                  name='email'
                                  value={evaluation ? evaluation.email : undefined}
                                  onChange={(event, value) => this.handleEvaluationChange(event.target.name, value)}
                                  errorText={this.state.errors.errorFields.email}
                                  style={styles.field}
                                />
                              </div>
                            </div>

                            <div
                              className='row'
                              style={styles.section}
                            >
                              <div
                                className='col-md-6 col-xs-12'
                              >
                                <RaisedButton
                                  label={this.props.intl.formatMessage(constants.messages.SEND_EVALUATION)}
                                  primary={true}
                                  onClick={this.handleSend}
                                  disabled={!evaluation || !evaluation.satisfaction_note}
                                  style={styles.button}
                                />
                              </div>

                              <div
                                className='col-md-6 col-xs-12'
                              >
                                <RaisedButton
                                  label={this.props.intl.formatMessage(constants.messages.CANCEL_BUTTON)}
                                  secondary={true}
                                  onClick={this.handleCancel}
                                  style={styles.button}
                                />
                              </div>
                            </div>
                          </React.Fragment>
                      }
                    </div>
                  </React.Fragment>
              }
            </div>
        }
      </BaseValidation>
    )
  }
}

const styles = {
  container: {
    textAlign: 'center',
    margin: '25px',
  },
  form: {
    boxShadow: '0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)',
    padding: '25px 35px 35px 35px',
    background: '#fff',
    minHeight: 834,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  message: {
    fontWeight: 300,
    fontSize: '1.25rem',
    textAlign: 'center',
  },
  icon: {
    height: 35,
    width: '100%'
  },
  section: {
    paddingBottom: 10,
  },
  field: {
    textAlign: 'left',
    marginBottom: '2em',
  },
  button: {
    marginTop: 10,
    minWidth: 200
  }
}

export default injectIntl(PrestationEvaluation)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/evaluation/PrestationEvaluation.js